module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-02@2x.6c90f829.jpg";